import { createNode } from '@glueapp/graph-types';
import { FileDataType } from '@glueapp/graph-types';
import axios from 'axios';
import { createNullable } from '@glueapp/graph-types';

export const LoadFile = createNode({
    id: 'LoadFile',
    name: 'Load File',
    description: 'Loads a file from a URL',
    aiDescription:
        'Downloads a file from a URL. Connect a URL string to the "URL" input port; the "File" output port provides the file data (nullable -- returns null on failure). This is an async node.',
    category: 'File',
    color: '#00af7a',
    inPorts: {
        URL: { kind: 'string' },
    },
    outPorts: {
        File: createNullable(FileDataType),
    },
    isAsync: true,
    execute: async function (input) {
        const url = input.inPorts.URL;

        try {
            const response = await axios.get(url, {
                responseType: 'blob',
            });

            return {
                output: {
                    File: {
                        fileType: response.data.type ?? 'unknown',
                        data: response.data,
                    },
                },
            };
        } catch (e) {
            return { output: { File: null } };
        }
    },
});
